export default "__VITE_ASSET__Crs_6E0o__"